import { updateQueryStringParam, getQueryParams } from '../common/util'

class AppState {
  bot = null

  setBot(bot) {
    this.bot = bot
  }

  hasIntro() {
    return this.bot.pwa && this.bot.pwa.intro_screen
  }

  checkEmbedded() {
    if (this.isEmbedded()) {
      localStorage.splashDone = 'yes'
      updateQueryStringParam('embedded', '1')
    }
  }

  isEmbedded() {
    return document.location.pathname === '/embed' || document.location.pathname === '/pwa_embedded.html'
  }

  hasSplash() {
    return this.bot.pwa && this.bot.pwa.splash_screen
  }

  hasStartScreen() {
    const { pwa } = this.bot
    return (
      pwa &&
      pwa.start_screen &&
      ((pwa.start_screen.home_buttons && pwa.start_screen.home_buttons.length > 0) ||
        pwa.start_screen.new_conversation_button)
    )
  }

  introDone() {
    return localStorage.introDone === 'yes'
  }

  splashDone() {
    if (getQueryParams().u) {
      localStorage.splashDone = 'yes'
    }
    return localStorage.splashDone === 'yes'
  }

  showBackButton() {
    return ((this.introDone() && this.hasIntro()) || !this.hasIntro()) && this.hasStartScreen()
  }

  setIntroDone(flag) {
    if (flag) {
      localStorage.introDone = 'yes'
    } else {
      delete localStorage.introDone
    }
  }

  setSplashDone(flag) {
    if (flag) {
      localStorage.splashDone = 'yes'
    } else {
      delete localStorage.splashDone
    }
  }
}

export default new AppState()
